import {BaseService} from "./BaseService";
import {ApiResponse} from "../models/ApiResponse";
import {NewContact} from "../models/Contact";

export class ErlService extends BaseService {

    /**
     * create contact
     * @param contact
     */
    async createInvestmentPartner(contact: NewContact) {
        return new Promise<ApiResponse>((resolve, reject) => {
            fetch('/wp-json/renditepartner/v1/welcome-assistant/sign-up', {
                method: 'POST',
                headers: this.apiHeaders,
                body: JSON.stringify(contact)
            }).then(res => this.factoryApiResponse(res)).then((apiResponse: ApiResponse) => {
                if (apiResponse.success) {
                    resolve(apiResponse);
                } else {
                    reject(apiResponse);
                }
            }).catch(reason => {
                reject(reason);
            });
        });
    }

}
